import React from 'react';
import { Link } from 'react-router-dom';

import { Lock } from 'lucide-react';

export type PremiumGateProps = {
  isAllowed: boolean;
  title?: string;
  description?: string;
  ctaLabel?: string;
  ctaTo?: string; // route interne (admin) vers pricing/settings
  children: React.ReactNode;

  // optionnel : si tu veux afficher le contenu mais juste le désactiver
  blurClassName?: string;
};

export default function PremiumGate({
  isAllowed,
  title = 'Fonctionnalité Premium',
  description = 'Vous devez être abonné pour accéder à cette fonctionnalité.',
  ctaLabel = 'Devenir abonné',
  ctaTo = '/settings/billing',
  children,
  blurClassName = 'blur-md',
}: PremiumGateProps) {
  if (isAllowed) return <>{children}</>;

  return (
    <div className='relative'>
      {/* Bandeau sticky */}
      <div className='sticky top-0 z-50'>
        <div className='mx-auto max-w-6xl px-8 pt-6'>
          <div className='flex flex-col md:flex-row items-start gap-3 rounded-2xl border border-amber-200 bg-amber-50 p-4 text-amber-900'>
            <div className='mt-0.5'>
              <Lock className='h-5 w-5' />
            </div>

            <div className='flex-1 min-w-0'>
              <p className='font-semibold'>{title}</p>
              <p className='text-sm text-amber-800'>{description}</p>
            </div>

            <Link
              to={ctaTo}
              className='shrink-0 rounded-xl bg-amber-600 px-4 py-2 text-sm font-semibold text-white hover:bg-amber-700'
            >
              {ctaLabel}
            </Link>
          </div>
        </div>
      </div>

      {/* Contenu “bloqué” */}
      <div className={`pointer-events-none select-none ${blurClassName}`}>{children}</div>

      {/* Overlay pour renforcer l’impression “inaccessible” */}
      <div className='absolute inset-0 z-40' aria-hidden='true'>
        {/* voile léger par-dessus le blur (facultatif) */}
        <div className='absolute inset-0 bg-white/20' />
      </div>
    </div>
  );
}
